import React, { useState } from 'react';

const useFilters = () => {
  const [filters, setFilters] = useState({});
  const getFilterData = (response: any) => {
    const tempKeys = response && Object.keys(response[0]);
    let temp = { ...filters };
    for (let i = 0; i < tempKeys?.length; i++) {
      temp = { ...temp, [tempKeys[i]]: [...new Set(response?.map((x: any) => x?.[tempKeys[i]]))] };
    }
    setFilters(temp);
    return temp;
  };
  return { getFilterData };
};

export default useFilters;
